import { NgClass } from "@angular/common";
import { AfterViewInit, ChangeDetectorRef, Component, DestroyRef, effect, ElementRef, NgZone, OnDestroy, OnInit, signal, ViewChild, ChangeDetectionStrategy, inject } from "@angular/core";
import { toSignal } from "@angular/core/rxjs-interop";
import { AbstractControl, FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, ValidationErrors, Validators } from "@angular/forms";
import { MatBottomSheet } from "@angular/material/bottom-sheet";
import { MatIcon } from "@angular/material/icon";
import { MatProgressSpinner } from "@angular/material/progress-spinner";
import { ActivatedRoute, Data, Router } from "@angular/router";
import { Network } from "@capacitor/network";
import { AuthService } from "@core/auth.service";
import { IonicModule, ModalController, PickerController } from "@ionic/angular";
import { pickerController } from "@ionic/core";
import { TranslatePipe, TranslateService } from "@ngx-translate/core";
import * as moment from "moment";
import { interval, Subscription, Subject, timer } from "rxjs";
import { map, take,finalize, takeUntil, filter, timeout } from "rxjs/operators";
import { getAuth } from "firebase/auth";
import { BasePaymentService } from "../payment/services/base-payment-service";
import { PaymentNavigationService, profileCompletionState } from "../payment/services/payment-navigation-service";
import { bounceIn } from "src/app/animations/custom.animation";
import { MobileNumberUpdateComponent } from "src/app/components/mobile-number-update/mobile-number-update.component";
import { GTMSegmentService } from "src/app/services/gtm-segment.service";
import { PaymentService } from "src/app/services/payment.service";
import { SafeLocalStorageService } from "src/app/services/safe-local-storage.service";
import { VoucherService } from "src/app/services/vouchers.service";
import { AccountRepositoryService } from "../../account/account-repository.service";
import { MatFormField, MatInput, MatLabel } from "@angular/material/input";
import { MatOption, MatSelect } from "@angular/material/select";

@Component({
  selector: "app-free-reg-complete-profile",
  templateUrl: "./free-reg-complete-profile.component.html",
  styleUrls: ["./free-reg-complete-profile.component.scss", "../onesignal.scss"],
  animations: [bounceIn],
  standalone: true,
  imports: [
    IonicModule,
    FormsModule,
    ReactiveFormsModule,
    NgClass,
    MatProgressSpinner,
    MatIcon,
    TranslatePipe,
    MatFormField,
    MatSelect,
    MatOption,
  ],
  providers: [BasePaymentService, PaymentNavigationService],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FreeRegCompleteProfileComponent implements OnInit, OnDestroy, AfterViewInit {
  // Add destroy subject
  private destroy$ = new Subject<void>();
  /** Active timer subscriptions from safePatchValue, keyed by control name, for per-control coalescing. */
  private readonly pendingPatches = new Map<string, Subscription>();

  isEmpty = (val: any) =>
    val === undefined || val === null || val === "          " || val === "" || !(Object.keys(val) || val).length;
  proceed = true;
  text = "Cancel";
  done = "Done";
  spinnerAnimation = false;
  progressBar: number;
  completeRegistrationForm: FormGroup;
  touched: boolean;
  syndicateId: any;
  timer$;
  sub: any;
  payment = true;
  sqlAPICallResponse: any;
  facebook: any;
  google: any;
  pageName: any;
  userDetails: any;
  isOnline: boolean = true;
  dobDate: string;
  currencyArray: any[] = [];
  translatedToastMsg: any;
  selectedLanguage: string = "en";
  ipBasedUserCurrency: string;
  preferredCurrency: string = "GBP";
  preferredCurrencyExists: boolean = true;
  public maxDateOfBirth: string;
  public TP1: any;
  public TP2: any;
  public TP3: string;
  public T_ID: string;
  public Prosub_id: any;
  private safeLocalStorage = inject(SafeLocalStorageService);
  private readonly destroyRef = inject(DestroyRef);
  readonly pageNameSignal = signal<string | null>(null);
  readonly isOnlineSignal = signal<boolean>(true);
  // True once Ionic custom elements are registered; only ever transitions false→true.
  readonly viewReady = signal<boolean>(false);
  // Prevents duplicate Promise.race chains if ionViewDidEnter fires multiple times
  // before elements resolve.
  private waitingForIonicElements = false;
  // Single destroyed flag registered once via destroyRef; avoids repeated onDestroy registrations.
  private isDestroyed = false;
  // Tracks the 3-second fallback timeout set in ensureIonicElementsReady().
  // Cleared once the race resolves (elements ready or timeout fires).
  // NOT cleared on destroy: clearing it would leave the Promise.race permanently
  // pending if elements never register. markViewReady() guards all side effects
  // with isDestroyed, so a late timeout callback after destroy is safely a no-op.
  private elementReadinessTimeoutId: ReturnType<typeof setTimeout> | undefined;
  public paidProfileMode = false;
  public profileDecisionPending = false;
  private profileDecisionKnown = false;
  private profileSnapshotSubscription?: Subscription;
  private profilePrefillUserId: string | null = null;
  private profileOwnerUserId: string | null | undefined;
  private profileRequiresScopedSnapshot = false;
  public profileSaveInProgress = false;
  public profileSavePending = false;
  public profileCompleted = false;
  private profileCompletionUserId: string | null = null;
  public profileStatusMessage = "";
  private profileViewActive = false;
  private profileNavigationEpoch = 0;
  private profileContinuationInProgress = false;
  private profileContinuationFinished = false;
  private profileContinuationTimer: ReturnType<typeof setTimeout> | null = null;
  private profileContinuationAttempts = 0;
  private profileSaveAttempt: { userId: string; values: Record<string, any>; signature: string } | null = null;
  private profileUninvokedRetryTimer: ReturnType<typeof setTimeout> | null = null;
  private profileUninvokedRetryAttempts = 0;
  facebookSign = "Sign in with Facebook";
  gmailSign = "Sign in with Gmail";
  toastMessage = "your profile has been updated";
  public defaultDateOfBirth: string;
  public isDateModalOpen: boolean = false; // Control date picker modal
  newPhoneNumber: string;
  newDialCode: string;
  countryCode: string;
  dialCode: string;
  incorrectPhoneNumber: any = false;
  phoneInValid: boolean;
  @ViewChild("phoneNumberInput", { static: true }) phoneNumberInput: ElementRef;
  updateAccountDetails$: Subscription;
  isSpoofMsn = false;
  userMsn: string;
  constructor(
    private fb: FormBuilder,
    private bottomSheet: MatBottomSheet,
    private changeDetectorRef: ChangeDetectorRef,
    private router: Router,
    private GTMServise: GTMSegmentService,
    private authService: AuthService,
    private paymentService: PaymentService,
    private accountService: AccountRepositoryService,
    private modalController: ModalController,
    public route: ActivatedRoute,
    public translate: TranslateService,
    private voucherService: VoucherService,
    private pickerController: PickerController,
    private ngZone: NgZone,
    private paymentNavigationService: PaymentNavigationService
  ) {
    // Safely initialize tracking parameters
    this.TP1 = this.safeLocalStorage.getItem("TP1");
    this.TP2 = this.safeLocalStorage.getItem("TP2");
    this.TP3 = this.safeLocalStorage.getItem("TP3");
    this.T_ID = this.safeLocalStorage.getItem("T_ID");
    this.Prosub_id = this.safeLocalStorage.getItem("prosub_id");
    const safeRequestIdleCallback = (cb: () => void) => {
      if (typeof window.requestIdleCallback === "function") {
        window.requestIdleCallback(cb);
      } else {
        setTimeout(cb, 0);
      }
    };

    const selectedLanguageSignal = toSignal(this.authService.selectedlanguage$, { initialValue: "en" });
    const constantsMsgSignal = toSignal(this.authService.getConstantsMsg$, { initialValue: null });
    const currencyListSignal = toSignal(this.authService.getCurrencyList$, { initialValue: null });
    const phoneNumberSignal = toSignal(this.accountService.phoneNumberUpdate$, { initialValue: null });

    try {
      effect(() => {
        try {
          const lang = selectedLanguageSignal();
          this.selectedLanguage = lang || "en";
          this.translate.use(lang || "en");
        } catch (error) {
          return error;
        }
      });

      effect(() => {
        try {
          const msg = constantsMsgSignal();
          this.translatedToastMsg = msg?.static_messages_pwa;
        } catch (error) {
          return error;
        }
      });

      safeRequestIdleCallback(() => {
        try {
          this.GTMServise.GTMInitilization();
        } catch (error) {
          return error;
        }
      });

      this.validateSignUpForm();
      this.synchronizeProfileOwner();
      this.configurePaidProfileRequirements();
      this.applyStoredMsnFallback();

      this.authService.userDetails$.pipe(takeUntil(this.destroy$)).subscribe((data: Data) => {
        this.prefillProfileData(data);
      });

      this.route.queryParamMap.pipe(take(1)).subscribe((params) => {
        try {
          this.syndicateId = params?.get("sid") || "";
        } catch (error) {
          return error;

        }
      });

      effect(() => {
        try {
          const data = phoneNumberSignal();
          if (!data || this.paidProfileMode || this.hasConfirmedPaidJourney()) return;
          const { dialCode, number, iso2 } = data;
          const isEmpty = !number && !dialCode;
          const phoneNumber = isEmpty ? this.userMsn : number;
          const countryCode = isEmpty ? this.countryCode : dialCode;
          if (this.completeRegistrationForm?.controls) {
            this.safePatchValue('msn', `${dialCode} ${number}`);
            this.safePatchValue('phoneNumber', phoneNumber);
            this.safePatchValue('dialCode', countryCode);
          }
          this.classData = `flag-icon flag-icon-${iso2?.toLowerCase()} flag-icon-squared`;
        } catch (error) {
          return error;

        }
      });

      safeRequestIdleCallback(() => {
        try {
          this.authService
            .getCurrentLoggedinUser()
            .then((d) => {
              try {
                this.facebook =
                  d.providerData?.find((f) => f.providerId.includes("facebook")) || this.getProviderID("facebook")
                    ? "Connected with Facebook"
                    : this.facebookSign;

                this.google =
                  d.providerData?.find((f) => f.providerId.includes("google")) || this.getProviderID("google")
                    ? "Gmail account connected "
                    : this.gmailSign;
              } catch (error) {
                return error;

              }
            })
            .catch((error) => {
              return error;

            });
        } catch (error) {
          return error;

        }
      });

      effect(() => {
        try {
          const data = currencyListSignal();
          const currencyData = Array.isArray(data) ? data : [data];
          this.currencyArray = currencyData
            .filter((item) => item && typeof item === "object")
            .map((currency) => currency?.currency_code);
          this.ipBasedUserCurrency = this.currencyArray.includes(this.authService?.ipBasedCurrency)
            ? this.authService.ipBasedCurrency
            : "GBP";
        } catch (error) {
          return error;

        }
      });

      safeRequestIdleCallback(() => {
        try {
          this.dateCalculator();
        } catch (error) {
          return error;
        }
      });
    } catch (error) {
      return error;
    }
  }
    /** Helper method to safely patch value without overwriting user input */
        private safePatchValue<K extends keyof typeof this.completeRegistrationForm.controls>(
      controlName: K,
      value: typeof this.completeRegistrationForm.controls[K]['value'],
      userId?: string
    ) {
      if (!this.completeRegistrationForm || (userId && userId !== this.currentProfileUserId())) return;
      const control = this.completeRegistrationForm.get(controlName as string);
      if (!control) return;
      // Skip if backend value missing OR user already edited
      if (value == null || value === '' || control.dirty || Object.is(control.value, value)) return;
      // Use timer(0) (macrotask) instead of Promise.resolve() (microtask) so that
      // the patch lands AFTER the current change-detection cycle completes. The
      // Promise microtask was firing mid-cycle and causing Angular's view-refresh
      // functions to recurse infinitely (RangeError: Maximum call stack size exceeded).
      // takeUntil(this.destroy$) auto-cancels when ngOnDestroy calls destroy$.next(),
      // preventing stale patches and closure leaks after component teardown.
      //
      // Per-control coalescing: cancel any prior pending timer for this control so
      // that only the latest backend value is applied and no stale queued value
      // can overwrite a more recent one.
      const key = controlName as string;
      this.pendingPatches.get(key)?.unsubscribe();
      const ownerUserId = this.currentProfileUserId();
      const sub = timer(0).pipe(
        takeUntil(this.destroy$),
        // finalize runs on both normal completion AND cancellation (takeUntil /
        // unsubscribe), so the map entry is always removed regardless of how the
        // timer ends.
        finalize(() => this.pendingPatches.delete(key))
      ).subscribe(() => {
        if (ownerUserId !== this.currentProfileUserId() || (userId && userId !== ownerUserId)) return;
        // Re-fetch the control inside the callback: the form may have been
        // rebuilt between scheduling and execution, so closing over the original
        // reference could patch a detached control.
        const latestControl = this.completeRegistrationForm?.get(key);
        if (!latestControl || value == null || value === '' || latestControl.dirty || Object.is(latestControl.value, value)) return;
        latestControl.patchValue(value, { emitEvent: false, onlySelf: true });
        this.completeRegistrationForm.updateValueAndValidity({ emitEvent: false });
        this.changeDetectorRef.markForCheck();
      });
      this.pendingPatches.set(key, sub);
    }

  /**
   * Anonymous sales-journey users may reach this page before Firestore profile sync.
   * Fall back to MSN captured during partial registration.
   */
  private applyStoredMsnFallback(force = false): void {
    if (this.paidProfileMode || this.hasConfirmedPaidJourney() || this.profileRequiresScopedSnapshot) return;
    const storedMsn =
      this.safeLocalStorage.getItem("msn") ||
      this.authService.userMSN$?.value ||
      "";
    if (!storedMsn || !this.completeRegistrationForm?.controls) {
      return;
    }

    const phoneControl = this.completeRegistrationForm.get("phoneNumber");
    if (!force && phoneControl?.value) {
      return;
    }

    const countryCodeDigits = this.safeLocalStorage.getItem("country_code") || "";
    this.userMsn = countryCodeDigits
      ? this.removeCountryCode(storedMsn, countryCodeDigits)
      : storedMsn;

    if (countryCodeDigits) {
      this.countryCode = `+ ${countryCodeDigits}`;
    }

    const dialCode = countryCodeDigits ? `+${countryCodeDigits}` : "+44";
    this.safePatchValue("dialCode", dialCode);
    this.safePatchValue("phoneNumber", this.userMsn || storedMsn);
    this.safePatchValue("msn", storedMsn);
  }
  classData = "flag-icon flag-icon-gb flag-icon-squared";
  pickerValue = "";
  titleOptions: string[] = [];

  ngOnDestroy() {
    this.ionViewWillLeave();
    this.isDestroyed = true;
    this.destroy$.next();
    this.destroy$.complete();
    if (this.updateAccountDetails$) {
      this.updateAccountDetails$?.unsubscribe();
    }
  }

  ngOnInit() {
    // Register destroyed flag once so ensureIonicElementsReady never adds
    // duplicate callbacks. The timeout is intentionally NOT cleared here:
    // clearing it would leave the Promise.race pending forever if custom
    // elements never register. Instead, markViewReady() guards all side
    // effects with isDestroyed, so the timeout resolving after destroy is harmless.
    this.destroyRef.onDestroy(() => { this.isDestroyed = true; });
    this.initMaxDateOfBirth();
    try {
      // ✅ Initialize form language & currency at start (no need to patch later)
          this.completeRegistrationForm.patchValue({
            currentLanguage: localStorage.getItem('language_code'),
            currency: localStorage.getItem('user_currency'),
          });
      this.authService.commonUserCheck(() => {
        Network.addListener("networkStatusChange", (e) => {
          this.isOnlineSignal.set(e.connected);
          if (e.connected) this.resumeProfileContinuation();
        });

        this.route.params.subscribe((data) => {
          if (data && data?.pageName) {
            this.pageName = data?.pageName;
          }
        });

        this.translate
          .get([
            "complete-registration.toast-message",
            "complete-registration.cancel",
            "complete-registration.done",
            "complete-registration.facebook",
            "complete-registration.gmail",
            "complete-registration.mr",
            "complete-registration.mrs",
            "complete-registration.miss",
          ])
          .subscribe((res: string) => {
            this.toastMessage = res["complete-registration.toast-message"];
            this.text = res["complete-registration.cancel"];
            this.done = res["complete-registration.done"];
            this.facebookSign = res["complete-registration.facebook"];
            this.gmailSign = res["complete-registration.gmail"];
            this.titleOptions.push(
              res["complete-registration.mr"],
              res["complete-registration.mrs"],
              res["complete-registration.miss"]
            );
          });

        requestIdleCallback(() => {
          const dob = this.paidProfileMode || this.hasConfirmedPaidJourney() || this.profileRequiresScopedSnapshot
            ? null : localStorage.getItem("defaultDob");
          if (dob) {
            this.defaultDateOfBirth = dob;
            const formattedDate = moment(new Date(dob)).format("MM/DD/yyyy");
            this.completeRegistrationForm.get("date_of_birth")?.patchValue(formattedDate);
            this.changeDetectorRef.markForCheck();
          } else {
            this.dateCalculator();
          }
        });
      });
    } catch (error) {
      return error;
    }
  }

  getProviderID(provider: string): boolean {
    const providerId = localStorage.getItem("providerId");
    if (!providerId) {
      return false;
    }
    return this.isSpoofMsn && providerId?.search(provider) > -1;
  }

  getMSN() {
    return this.completeRegistrationForm?.controls?.msn?.value;
  }

  ionViewDidEnter() {
    this.ensureIonicElementsReady();
  }

  /**
   * Waits for the Ionic custom elements used in this form to be registered
   * before setting viewReady, preventing the Stencil lazy-instance race where
   * attributeChangedCallback fires before the component instance exists.
   *
   * Called from both ionViewDidEnter (normal Ionic page lifecycle) and
   * ngAfterViewInit (fallback for non-Ionic rendering contexts / tests).
   */
  private ensureIonicElementsReady(): void {
    // Already ready (e.g. navigating back) or a resolution is already in-flight.
    if (this.viewReady() || this.waitingForIonicElements) {
      return;
    }

    // Guard against non-browser/test environments where customElements or
    // whenDefined may be absent or incompletely mocked.
    if (typeof customElements === 'undefined' || typeof customElements.whenDefined !== 'function') {
      this.markViewReady();
      return;
    }

    // Only the elements whose aria-label/placeholder watchers can trigger the
    // Stencil race need to be awaited before rendering. ion-grid, ion-modal etc.
    // do not have aria watchers and need not block the gate.
    this.waitingForIonicElements = true;

    const clearReadinessTimeout = () => {
      if (this.elementReadinessTimeoutId !== undefined) {
        clearTimeout(this.elementReadinessTimeoutId);
        this.elementReadinessTimeoutId = undefined;
      }
    };

    // A 3-second timeout fallback ensures the page is never permanently blank
    // if element registration is unexpectedly delayed.
    const timeout = new Promise<void>(resolve => {
      this.elementReadinessTimeoutId = setTimeout(resolve, 3000);
    });

    // Wrap construction of the race in try/catch: if whenDefined() throws
    // synchronously (e.g. incomplete test mock), fall back immediately rather
    // than leaving the form hidden.
    let racePromise: Promise<void>;
    try {
      // Normalize Promise.all result to void so Promise.race types correctly
      // against the timeout (which is already Promise<void>).
      const ionicReady: Promise<void> = Promise.all([
        customElements.whenDefined('ion-input'),
        customElements.whenDefined('ion-button'),
        customElements.whenDefined('ion-item'),
      ]).then((): void => undefined);
      racePromise = Promise.race([ionicReady, timeout]);
    } catch {
      clearReadinessTimeout();
      this.waitingForIonicElements = false;
      this.markViewReady();
      return;
    }

    racePromise
      .then(() => {
        clearReadinessTimeout();
        this.markViewReady();
      })
      .catch(() => {
        // whenDefined should not reject, but fall back gracefully if it does.
        clearReadinessTimeout();
        this.markViewReady();
      })
      .finally(() => {
        if (!this.isDestroyed) {
          this.waitingForIonicElements = false;
        }
      });
  }

  private markViewReady(): void {
    if (!this.isDestroyed) {
      this.viewReady.set(true);
      this.changeDetectorRef.markForCheck();
    }
  }

  // ionViewDidEnter() {
  //   /* Removing default down arrow mark (caret) from the element ion-select */
  //   const dropDownItems = document.querySelectorAll("ion-select");
  //   dropDownItems.forEach((dropDown) => {
  //     dropDown.shadowRoot.querySelectorAll(".select-icon-inner").forEach((elem) => {
  //       elem.setAttribute("style", "display: none;");
  //     });
  //   });
  // }

  noNumbersValidator(control: AbstractControl): ValidationErrors | null {
    // Use a regular expression to match any character except numbers (0-9).
    const regex = /^[^\d]+$/;
    if (!regex.test(control.value)) {
      return { noNumbers: true }; // Return error if no match
    }
    return null; // No error found
  }

  private validateSignUpForm() {
    this.completeRegistrationForm = this.fb.group(
      {
        name: [
          "",
          Validators.compose([Validators.required, Validators.minLength(1), this.noNumbersValidator.bind(this)]),
        ],
        surname: [
          "",
          Validators.compose([Validators.required, Validators.minLength(3), this.noNumbersValidator.bind(this)]),
        ],
        email: [
          "",
          Validators.compose([
            Validators.required,
            Validators.pattern("^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$"),
          ]),
        ],
        cemail: [
          "",
          Validators.compose([
            Validators.required,
            Validators.pattern("^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$"),
          ]),
        ],
        option: ["", Validators.required],
        currency: [""],
        date_of_birth: ["", Validators.compose([Validators.required, this.dateOfBirthValidation.bind(this)])],
        msn: [""],
        phoneNumber: ["", Validators.compose([Validators.required, Validators.maxLength(10)])],
        dialCode: ["", Validators.required],
      },
      { 
        updateOn: 'blur',
        validators: [(form: AbstractControl) => {
          const email = form.get('email');
          const cemail = form.get('cemail');
          if (email?.value !== cemail?.value) {
            return { match_error: true };
          }
          return null;
        }]
      }
    );

    // Re-render the OnPush view whenever the user edits a field. Note: async
    // validator status changes emit on statusChanges, not valueChanges; this
    // subscription only covers user-driven value updates. Programmatic patches
    // from safePatchValue use emitEvent:false and call markForCheck() directly,
    // so there is no double-scheduling for those paths.
    this.completeRegistrationForm.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.clearUninvokedProfileRetry();
        if (this.profileSaveAttempt && this.profileSaveAttempt.signature !== this.profileFormSignature()) {
          // An explicit edit owns the form now; a late save cannot replace it or navigate away.
          this.profileSaveAttempt = null;
          this.profileSaveInProgress = false;
          this.profileSavePending = false;
          this.profileStatusMessage = "";
        }
        this.changeDetectorRef.markForCheck();
      });
  }

  dateOfBirthValidation(control: FormControl) {
    if (control?.value) {
      let now = new Date();
      let dob = new Date(control.value);
      //This condition will check the date of birth is greater or equal to 18
      const eighteenYearsAgo: Date = new Date();
      eighteenYearsAgo.setFullYear(now.getFullYear() - 18);
      if (dob >= eighteenYearsAgo) {
        return { futureInvalidDate: true };
      }
    }
    return null;
  }
  ngAfterViewInit() {
    // maxDateOfBirth is initialized in ngOnInit via initMaxDateOfBirth()

    // Fallback: ensure Ionic elements are ready here too, so the form is never
    // permanently blank when the component is used outside an Ionic page lifecycle
    // (e.g. in unit tests where ionViewDidEnter is not called).
    this.ensureIonicElementsReady();
  }

  private initMaxDateOfBirth(): void {
    const date = new Date();
    date.setFullYear(date.getFullYear() - 18);
    date.setMonth(11);
    this.maxDateOfBirth = date.toISOString();
  }
  onCompleteRegistrationFormSubmit() { }

  editPhoneNumber() {
    this.bottomSheet.open(MobileNumberUpdateComponent, {
      panelClass: "mobile-update-bottomsheet",
      data: { phoneNumber: this.completeRegistrationForm?.controls?.phoneNumber?.value, isSpoofMsn: this.isSpoofMsn },
    });
  }

  // This method is used for 4d flow
  call4dFlow() {
    //  This method is used to navigate to voucherRedeemed page
    this.router.navigate(["/voucherRedeemed"], {
      queryParams: {
        prosub_id: this.Prosub_id,
        TP1: this.TP1 ? this.TP1 : "null",
        TP2: this.TP2 ? this.TP2 : "null",
        TP3: this.TP3 ? this.TP3 : "null",
        T_ID: this.T_ID ? this.T_ID : "",
      },
    });
    localStorage.removeItem("4dpage");
    localStorage.removeItem("4cpage");
  }

  private currentProfileUserId(): string | null {
    const user = getAuth().currentUser;
    return user && !user.isAnonymous ? user.uid : null;
  }

  /** A cached form and its async work must never move to a replacement account. */
  private synchronizeProfileOwner(): void {
    const userId = this.currentProfileUserId();
    if (this.profileOwnerUserId === undefined) {
      this.profileOwnerUserId = userId;
      return;
    }
    if (this.profileOwnerUserId === userId) return;
    this.profileOwnerUserId = userId;
    this.clearUninvokedProfileRetry();
    this.profileRequiresScopedSnapshot = true;
    ++this.profileNavigationEpoch;
    if (this.profileContinuationTimer != null) clearTimeout(this.profileContinuationTimer);
    this.profileContinuationTimer = null;
    this.profileContinuationInProgress = false;
    this.profileContinuationFinished = false;
    this.profileContinuationAttempts = 0;
    this.profileSaveAttempt = null;
    this.updateAccountDetails$?.unsubscribe();
    this.pendingPatches.forEach(patch => patch.unsubscribe());
    this.pendingPatches.clear();
    this.completeRegistrationForm.reset({}, { emitEvent: false });
    this.profilePrefillUserId = null;
    this.profileSavePending = false;
    this.profileSaveInProgress = false;
    this.spinnerAnimation = false;
    this.profileCompleted = false;
    this.profileCompletionUserId = null;
    this.profileDecisionKnown = false;
    this.profileStatusMessage = "";
    this.userMsn = "";
    this.countryCode = "";
    this.configurePaidProfileRequirements();
    void this.paymentNavigationService.clearPreparation?.();
    this.changeDetectorRef.markForCheck();
  }

  private hasConfirmedPaidJourney(): boolean {
    const journey = this.paymentService.confirmedPaidJourney;
    return !!journey && journey.userId === this.currentProfileUserId();
  }

  private profileFormSignature(values = this.completeRegistrationForm?.getRawValue()): string {
    return JSON.stringify(values || {});
  }

  private profileMatchesSubmitted(data: Data): boolean {
    const attempt = this.profileSaveAttempt;
    if (!attempt || profileCompletionState(data) !== true) return false;
    const values = attempt.values;
    const dateKey = (value: unknown) => {
      const date = new Date(String(value || ""));
      return Number.isNaN(date.getTime()) ? "" : `${date.getFullYear()}-${date.getMonth()}-${date.getDate()}`;
    };
    return data.name === values.name && data.surname === values.surname &&
      data.email === values.email && data.title === values.option &&
      !!dateKey(values.date_of_birth) && dateKey(data.date_of_birth) === dateKey(values.date_of_birth);
  }

  private observeProfileCompletion(data: Data): void {
    if (this.isDestroyed) return;
    this.synchronizeProfileOwner();
    const attempt = this.profileSaveAttempt;
    if (attempt) {
      if (attempt.userId === this.currentProfileUserId() &&
          attempt.signature === this.profileFormSignature() && this.profileMatchesSubmitted(data)) {
        this.acceptSavedProfile();
      }
    } else if (profileCompletionState(data) === true && this.hasConfirmedPaidJourney() &&
        !this.completeRegistrationForm?.dirty) {
      this.profileCompleted = true;
      this.profileCompletionUserId = this.currentProfileUserId();
      this.profileStatusMessage = "Your profile is complete.";
      this.resumeProfileContinuation();
    }
  }

  private configurePaidProfileRequirements(): void {
    this.paidProfileMode = this.hasConfirmedPaidJourney();
    this.profileDecisionPending = (this.paidProfileMode || this.profileRequiresScopedSnapshot) &&
      !this.profileDecisionKnown && !this.profileCompleted;
    // The existing persisted minimum is title/name/surname/email/DOB. Phone
    // verification remains in the separate legacy account flow, not this paid gate.
    const phone = this.completeRegistrationForm.get("phoneNumber");
    const dialCode = this.completeRegistrationForm.get("dialCode");
    phone.setValidators(this.paidProfileMode ? [] : [Validators.required, Validators.maxLength(10)]);
    dialCode.setValidators(this.paidProfileMode ? [] : [Validators.required]);
    phone.updateValueAndValidity({ emitEvent: false });
    dialCode.updateValueAndValidity({ emitEvent: false });
    this.completeRegistrationForm.updateValueAndValidity({ emitEvent: false });
  }

  private prefillProfileData(data: Data, userId?: string): void {
    this.synchronizeProfileOwner();
    // The unscoped cache is retained only for the legacy account flow. Paid
    // details and its completeness decision must come from the same server UID.
    if (userId ? userId !== this.currentProfileUserId() :
        this.paidProfileMode || this.hasConfirmedPaidJourney() || this.profileRequiresScopedSnapshot) return;
    if (userId && this.profileSaveAttempt?.userId === userId) return;
    if (!data) {
      if (!userId) this.applyStoredMsnFallback(true);
      return;
    }
    if (userId) {
      if (this.profilePrefillUserId && this.profilePrefillUserId !== userId) {
        this.pendingPatches.forEach(patch => patch.unsubscribe());
        this.pendingPatches.clear();
        this.completeRegistrationForm.reset({}, { emitEvent: false });
        this.profileSaveAttempt = null;
        this.profileSavePending = false;
        this.profileSaveInProgress = false;
      }
      this.profilePrefillUserId = userId;
    }
    const storedMsn = userId ? "" : this.safeLocalStorage.getItem("msn") || this.authService.userMSN$?.value || "";
    const countryCode = data.country_code || (userId ? "" : this.safeLocalStorage.getItem("country_code"));
    const msn = data.msn || storedMsn;
    this.userMsn = this.removeCountryCode(msn, countryCode);
    this.countryCode = countryCode ? `+ ${countryCode}` : "";
    this.preferredCurrencyExists = !!data.preferred_currency;
    this.isSpoofMsn = data.spoof_msn;
    if (!this.isSpoofMsn) this.safePatchValue("phoneNumber", this.userMsn, userId);
    this.safePatchValue("dialCode", countryCode ? `+${countryCode}` : "", userId);
    this.safePatchValue("option", data.title || "", userId);
    this.safePatchValue("name", data.name || "", userId);
    this.safePatchValue("surname", data.surname || "", userId);
    this.safePatchValue("email", data.email || "", userId);
    this.safePatchValue("cemail", data.email || "", userId);
    this.safePatchValue("date_of_birth", data.date_of_birth || "", userId);
    if (!userId && !this.completeRegistrationForm.get("phoneNumber")?.value) this.applyStoredMsnFallback(true);
  }

  private acceptProfileSnapshot(snapshot: { userId: string; data: Data } | null): void {
    this.synchronizeProfileOwner();
    if (!snapshot || snapshot.userId !== this.currentProfileUserId()) return;
    if (this.paidProfileMode || this.hasConfirmedPaidJourney() || this.profileRequiresScopedSnapshot) {
      this.prefillProfileData(snapshot.data, snapshot.userId);
    }
    if (profileCompletionState(snapshot.data) !== null) {
      this.profileDecisionKnown = true;
      this.profileDecisionPending = false;
      this.changeDetectorRef.markForCheck();
    }
    this.observeProfileCompletion(snapshot.data);
  }

  ionViewWillEnter(): void {
    this.profileViewActive = true;
    this.synchronizeProfileOwner();
    if (this.profileCompletionUserId && this.profileCompletionUserId !== this.currentProfileUserId()) {
      this.profileCompleted = false;
      this.profileDecisionKnown = false;
      this.profileContinuationFinished = false;
      this.profileCompletionUserId = null;
      this.profileSaveAttempt = null;
      this.profileSavePending = false;
      this.profileSaveInProgress = false;
      this.profileStatusMessage = "";
    }
    this.configurePaidProfileRequirements();
    this.profileSnapshotSubscription?.unsubscribe();
    this.profileSnapshotSubscription = this.paymentNavigationService.profileSnapshot$()
      .pipe(takeUntil(this.destroy$)).subscribe(snapshot => this.acceptProfileSnapshot(snapshot));
    this.resumeProfileContinuation();
  }

  ionViewWillLeave(): void {
    this.profileViewActive = false;
    this.clearUninvokedProfileRetry();
    this.profileSnapshotSubscription?.unsubscribe();
    this.profileSnapshotSubscription = undefined;
    ++this.profileNavigationEpoch;
    this.profileContinuationInProgress = false;
    if (this.profileContinuationTimer != null) clearTimeout(this.profileContinuationTimer);
    this.profileContinuationTimer = null;
    void this.paymentNavigationService.clearPreparation?.();
  }

  private acceptSavedProfile(): void {
    if (this.profileCompleted) return;
    this.clearUninvokedProfileRetry();
    const values = this.profileSaveAttempt?.values;
    this.profileSavePending = false;
    this.profileSaveInProgress = false;
    this.spinnerAnimation = false;
    this.profileCompleted = true;
    this.profileDecisionKnown = true;
    this.profileDecisionPending = false;
    this.profileCompletionUserId = this.currentProfileUserId();
    this.profileStatusMessage = "Your profile is complete.";
    this.changeDetectorRef.markForCheck();
    this.resumeProfileContinuation();
    if (values) {
      try {
        this.GTMServise.FB_advanced_matching("", values.email, values.name, values.surname, values.date_of_birth);
        this.GTMServise.purchaseTagDetails$?.next(values);
      } catch (error) { this.authService.errorHandlerLogs("Profile analytics unavailable", error); }
    }
  }

  private resumeProfileContinuation(): void {
    this.synchronizeProfileOwner();
    if (!this.profileCompleted || !this.profileViewActive || this.isDestroyed ||
        this.profileContinuationInProgress || this.profileContinuationFinished ||
        this.profileContinuationTimer != null || !this.isOnlineSignal() || !this.currentProfileUserId() ||
        this.profileCompletionUserId !== this.currentProfileUserId()) return;
    void this.continueCompletedProfile();
  }

  private async continueCompletedProfile(): Promise<void> {
    const epoch = this.profileNavigationEpoch;
    const userId = this.currentProfileUserId();
    const isCurrent = () => !this.isDestroyed && this.profileViewActive &&
      epoch === this.profileNavigationEpoch && userId === this.currentProfileUserId() &&
      this.profileCompletionUserId === userId;
    this.profileContinuationInProgress = true;
    try {
      const flow = localStorage.getItem("flowPath");
      if (flow === "free-reg-step4d") {
        this.call4dFlow();
      } else if (flow === "free-reg-step4g") {
        if (!await this.router.navigateByUrl("mainTabs/tabs/syndicate?trigger=activated")) throw new Error("Profile continuation cancelled");
      } else if (this.hasConfirmedPaidJourney() || ["free-reg-step4c", "free-reg-step4a", "free-reg-step4h", "free-reg-step4b", "free-reg-step4j"].includes(flow)) {
        localStorage.setItem("sjFlow", "addCard");
        await this.paymentNavigationService.openConfirmedTickets({
          Prosub_id: this.Prosub_id, TP1: this.TP1, Tp2: this.TP2, TP3: this.TP3, T_ID: this.T_ID,
          upsellID: "", timerOn: false, spinnerAnimation: false, isPaymentDone: true,
          addingCard: false, addNewCardInProgress: false, _syndicateId: this.syndicateId,
          isCurrent, getCheckCardDetailId: () => ({}), onStateChange: () => {},
        });
      } else {
        if (!await this.router.navigateByUrl("mainTabs/tabs/home")) throw new Error("Profile continuation cancelled");
      }
      if (isCurrent()) this.profileContinuationFinished = true;
    } catch (error) {
      if (!isCurrent()) return;
      this.authService.errorHandlerLogs("Saved profile continuation is preparing", error);
      this.profileStatusMessage = "Your tickets are being prepared.";
      const delay = ++this.profileContinuationAttempts <= 2 ? 2000 : 30000;
      this.profileContinuationTimer = setTimeout(() => {
        this.profileContinuationTimer = null;
        this.resumeProfileContinuation();
      }, delay);
    } finally {
      if (isCurrent()) {
        this.profileContinuationInProgress = false;
        this.changeDetectorRef.markForCheck();
      }
    }
  }

  CompleteRegistration() {
    this.synchronizeProfileOwner();
    if (this.completeRegistrationForm.status !== "VALID" || this.profileSaveInProgress ||
        this.profileSavePending || this.profileCompleted || this.profileDecisionPending || this.isDestroyed) return;
    const userId = this.currentProfileUserId();
    if (!userId) return;
    this.clearUninvokedProfileRetry(false);
    const values = this.completeRegistrationForm.getRawValue();
    const attempt = { userId, values, signature: this.profileFormSignature(values) };
    const offerId = this.currentProfileOfferId();
    const viewEpoch = this.profileNavigationEpoch;
    this.profileSaveAttempt = attempt;
    this.profileSaveInProgress = true;
    this.profileSavePending = true;
    this.profileStatusMessage = "We're saving your details...";
    this.spinnerAnimation = true;
    // Freeze the submitted values: a delayed UID lookup must not read later edits.
    const controls = Object.fromEntries(Object.entries(values).map(([name, value]) => [name, { value }]));
    const isCurrent = () => !this.isDestroyed && this.profileSaveAttempt === attempt &&
      attempt.userId === this.currentProfileUserId() && attempt.signature === this.profileFormSignature();
    this.updateAccountDetails$ = this.accountService.updateAccountDetails(controls, attempt.userId).pipe(
      take(1), timeout({ first: 20000 }), takeUntil(this.destroy$),
      finalize(() => {
        if (this.isDestroyed || this.profileSaveAttempt !== attempt) return;
        this.profileSaveInProgress = false;
        this.spinnerAnimation = false;
        this.changeDetectorRef.markForCheck();
      }),
    ).subscribe({
      // SUCCESS from apivalidateasyncv2 means the write was accepted — continue
      // immediately. Snapshot matching remains the recovery path for PENDING /
      // delayed projections when the transport does not return SUCCESS.
      next: (result) => {
        if (!isCurrent()) return;
        const status = String(
          result?.response?.status ??
          result?.result?.response?.status ??
          result?.status ??
          ""
        ).toUpperCase();
        if (status === "SUCCESS") this.acceptSavedProfile();
      },
      error: (error) => {
        if (!isCurrent()) return;
        if (error?.code === "CALLABLE_NOT_INVOKED") {
          this.profileSaveAttempt = null;
          this.profileSavePending = false;
          this.profileSaveInProgress = false;
          this.spinnerAnimation = false;
          this.profileStatusMessage = "";
          this.changeDetectorRef.markForCheck();
          // Only a transport-proven non-invocation can resume this Save intent.
          // Accepted, timed-out or otherwise uncertain writes remain read-only.
          this.scheduleUninvokedProfileRetry(attempt, offerId, viewEpoch);
          return;
        }
        this.authService.errorHandlerLogs("Profile save confirmation is pending", error);
      },
    });
  }

  private currentProfileOfferId(): string {
    const params = this.route?.snapshot?.queryParams;
    return String(params?.prosub_id ?? params?.Prosub_ID ?? this.Prosub_id ?? "");
  }

  private clearUninvokedProfileRetry(resetAttempts = true): void {
    if (this.profileUninvokedRetryTimer != null) clearTimeout(this.profileUninvokedRetryTimer);
    this.profileUninvokedRetryTimer = null;
    if (resetAttempts) this.profileUninvokedRetryAttempts = 0;
  }

  private scheduleUninvokedProfileRetry(
    attempt: { userId: string; signature: string }, offerId: string, viewEpoch: number,
  ): void {
    const ownsIntent = () => !this.isDestroyed && this.profileViewActive &&
      this.profileNavigationEpoch === viewEpoch && this.currentProfileUserId() === attempt.userId &&
      this.profileFormSignature() === attempt.signature && this.currentProfileOfferId() === offerId &&
      !this.profileSaveAttempt && !this.profileSavePending && !this.profileCompleted;
    if (!ownsIntent() || this.profileUninvokedRetryTimer != null) return;
    const attempts = this.profileUninvokedRetryAttempts ?? 0;
    this.profileUninvokedRetryAttempts = attempts + 1;
    const delay = Math.min(30000, 2000 * Math.pow(2, Math.min(attempts, 4)));
    this.profileUninvokedRetryTimer = setTimeout(() => {
      this.profileUninvokedRetryTimer = null;
      if (!ownsIntent()) return;
      if (!this.isOnlineSignal()) {
        this.scheduleUninvokedProfileRetry(attempt, offerId, viewEpoch);
        return;
      }
      this.CompleteRegistration();
    }, delay);
  }

  connect(connect: string) {
    if (!window.navigator.onLine) return;
    this.authService
      .socialLink(connect)
      .then((data: any) => {
        this.userDetails.unsubscribe();
        const userData = data?._tokenResponse;
        if (userData && userData?.displayName) {
          this.completeRegistrationForm?.patchValue({
            name: userData?.displayName?.split(" ")[0],
          });
        }

        if (userData && userData?.displayName) {
          this.completeRegistrationForm?.patchValue({
            surname: userData?.displayName?.split(" ")[1] ? userData?.displayName?.split(" ")[1] : "",
          });
        }

        if (userData && userData.email && userData.email != null) {
          this.completeRegistrationForm?.patchValue({
            email: userData?.email,
          });
        }

        this.updateAccountDetails$ = this.accountService.updateAccountDetails(this.completeRegistrationForm?.controls).subscribe();

        if (userData?.photoUrl) {
          this.accountService.updateProfileImage(`${userData?.photoUrl}?type=large`).subscribe();
        }

        this.authService
          .getConstantsMsg("1068")
          .then((translatedMsg) => {
            const defaultMsg = {
              message: {
                line_1: `${connect.toUpperCase()}   has been linked with your account`,
                line_2: "",
              },
              style: {
                icon: "tick circle success.png",
                type: "Success",
              },
            };
            translatedMsg.message.line_1 = connect.toUpperCase() + translatedMsg?.message?.line_1;
            this.authService.showToastMessage(translatedMsg, defaultMsg);
          })
          .catch((err) => {
            return err;
          });
        this.accountService.updateSocialConnect(true);
        if (connect == "facebook") {
          this.facebook = "Connected with Facebook";
        } else {
          this.google = "Gmail account connected";
        }
      })
      .catch((err) => {
        //this.authService.showToast(err.message ? err.message : "Something went wrong!", "Error", "");
        this.authService
          .getConstantsMsg("1112")
          .then((translatedMsg) => {
            const defaultMsg = {
              message: {
                line_1: "Something went wrong!",
                line_2: "",
              },
              style: {
                type: "Error",
                icon: "tick circle error.svg",
              },
            };
            this.authService.showToastMessage(translatedMsg, defaultMsg);
          })
          .catch((error) => {
            return error;
          });
        return err;
      });
  }
  startSpinner() {
    this.spinnerAnimation = true;
    this.progressBar = 0;
    this.timer$ = interval(60);
    this.sub = this.timer$.subscribe(
      (sec) => {
        this.progressBar = 0 + sec;
      },
      (err) => {
        return err;
      }
    );
  }

  fetchSyndicateAndShowTicket() {
    const flow = localStorage.getItem("sjFlow");
    const existingId = this.syndicateId || this.paymentService?.salesJournyPaymentDetails$?.value;

    // Checkout / add-card sales journey: open ticket UI immediately (polls until ready).
    if (flow && flow === "addCard") {
      if (existingId && existingId !== "0") {
        this.loadSyndicateProductsAndShow(existingId);
      } else {
        void this.showTicket({ syndicate_id: null, product: [] }, true);
      }
      return;
    }

    let sqlAPICall;
    let paymentSqlResp = this.paymentService?.paymentSqlResp$?.value;

    if (this.syndicateId) {
      sqlAPICall = this.syndicateId;
    } else if (this.paymentService?.salesJournyPaymentDetails$?.value) {
      sqlAPICall = this.paymentService?.salesJournyPaymentDetails$?.value;
    } else if (!paymentSqlResp) {
      // Prefer sales-journey ticket modal over a static generating dialog so tickets can appear ASAP.
      void this.showTicket({ syndicate_id: null, product: [] }, true);
      return;
    } else if (paymentSqlResp?.response?.status !== "SUCCESS") {
      /* const msg = this.translatedToastMsg?.["1046"]?.[this.selectedLanguage];
      this.authService.showToast(msg ? msg : "There is an issue with syndicate creation process", "Error", ""); */
      this.authService
        .getConstantsMsg("1046")
        .then((translatedMsg) => {
          const defaultMsg = {
            message: {
              line_1: "There is an issue with syndicate creation process",
              line_2: "",
            },
            style: {
              type: "Error",
              icon: "tick circle error.svg",
            },
          };
          this.authService.showToastMessage(translatedMsg, defaultMsg);
        })
        .catch((error) => {
          return error;
        });
      return;
    } else {
      sqlAPICall = paymentSqlResp?.response?.encrypt_syndicate_id;
    }
    if (sqlAPICall) {
      this.loadSyndicateProductsAndShow(sqlAPICall);
    } else {
      /*  const msg = this.translatedToastMsg?.["1015"]?.[this.selectedLanguage];
       this.authService.showToast(msg ? msg : "something went wrong!", "error", ""); */
      void this.showTicket({ syndicate_id: null, product: [] }, true);
    }
  }

  private loadSyndicateProductsAndShow(sqlAPICall: string): void {
      this.paymentService
        .getSyndicateInfoWithProducts(sqlAPICall)
        .pipe(
          map((detail: any) => {
            // ✅ Validate detail[0] exists and has a data() method
            if (!detail || !detail[0] || typeof detail[0]?.data !== 'function') {
              console.warn('Invalid syndicate data received');
              return null;
            }
            
            const syndicateInfo = detail[0].data();
            if (!syndicateInfo) {
              console.warn('Syndicate info is null or undefined');
              return null;
            }
            
            // Initialize product array
            syndicateInfo.product = [];
            
            // ✅ Safely handle product docs with proper null checks
            const productDocs = detail[1]?.docs;
            if (productDocs && Array.isArray(productDocs)) {
              for (let index = 0; index < productDocs.length; index++) {
                const productDoc = productDocs[index];
                // ✅ Only call data() if the document exists and has the method
                if (productDoc && typeof productDoc.data === 'function') {
                  syndicateInfo.product.push(productDoc.data());
                }
              }
            }
            
            if (!syndicateInfo?.encrypted_id && sqlAPICall) {
              syndicateInfo.encrypted_id = sqlAPICall;
            }

            syndicateInfo["cardType"] = "Managed";
            return syndicateInfo;
          }),
          filter((syndicateInfo) => syndicateInfo !== null)
        )
        .subscribe(
          (syndicateInfo) => {
            this.showTicket(syndicateInfo, true);
          },
          (err) => {
            return err;
          }
        );
  }

  async showTicket(syndicateInfo, fromPostPayment = false) {
    const isCheckoutNewCard =
      fromPostPayment && localStorage.getItem("sjFlow") === "addCard";
    const componentProps = fromPostPayment
      ? {
          syndicate: {
            ...syndicateInfo,
            syndicate_id: null,
            product: [],
          },
          isSalesJourney: true,
          isAddCardCashPurchase: isCheckoutNewCard,
        }
      : { syndicate: syndicateInfo };

    const ticketsModule = await import(
      "../../syndicate/syndicate-tickets/syndicate-tickets.component"
    ).catch((err) => {
      this.authService.errorHandlerLogs("showTicket: failed to load syndicate-tickets chunk", err);
      return null;
    });
    const SyndicateTicketsComponent = ticketsModule?.SyndicateTicketsComponent;
    if (!SyndicateTicketsComponent) {
      this.authService.errorHandlerLogs("showTicket: SyndicateTicketsComponent unavailable", null);
      this.authService.showToastMessage({}, "Something went wrong, please try again");
      return;
    }

    const syndicateTickets = await this.modalController.create({
      component: SyndicateTicketsComponent,
      componentProps,
      cssClass: "modal-fullScreen",
    });

    return await syndicateTickets?.present();
  }

  async openPicker(nColumn = 1, nOptions = 3, columnOptions = this.titleOptions) {
    this.touched = true;
    const columns = this.getColumns(nColumn, nOptions, columnOptions);
    const picker = await this.pickerController.create({
      columns: columns,
      buttons: [
        {
          text: this.text,
          role: "cancel",
        },
        {
          text: this.done,
          role: "done",
          handler: (value) => {
            value = Object.values(value);
            this.pickerValue = value[0]?.text;
            this.touched = false;
            this.completeRegistrationForm.controls["option"].setValue(this.pickerValue);
          },
        },
      ],
    });
    picker.addEventListener("ionPickerColChange", (event: CustomEvent) => {
      try {
        const selectedIndex = event?.detail?.selectedIndex;
        const options = event?.detail?.options || [];
        if (selectedIndex >= 0 && selectedIndex < options.length) {
          const selectedTitle = options[selectedIndex]?.text;
          if (selectedTitle) {
            this.pickerValue = selectedTitle;
            this.touched = false;
            this.completeRegistrationForm.controls.option?.setValue(this.pickerValue);
          }
        }
      } catch (error) {
        console.error("Error handling picker column change:", error);
        return error;
      }
    });
    await picker.present();
  }

  async openCurrencyPicker(nColumn = 1, nOptions = this.currencyArray.length, columnOptions = [this.currencyArray]) {
    this.touched = true;
    const picker = await pickerController.create({
      columns: this.getColumns(nColumn, nOptions, columnOptions),
      buttons: [
        {
          text: this.text,
          role: "cancel",
        },
        {
          text: this.done,
          role: "done",
          handler: (value) => {
            value = Object.values(value);
            this.preferredCurrency = value[0]?.text;
            this.touched = false;
            this.completeRegistrationForm.controls["currency"].setValue(this.preferredCurrency);
          },
        },
      ],
    });
    await picker.present();
  }

  getColumns(numColumns, numOptions, columnOptions) {
    let columns = [];
    for (let i = 0; i < numColumns; i++) {
      columns.push({
        name: `${i}`,
        options: this.getColumnOptions(i, numOptions, columnOptions),
      });
    }

    return columns;
  }

  getColumnOptions(columnIndex, numOptions, columnOptions) {
    let options = [];
    if (columnOptions[columnIndex]) {
      for (let [index, text] of columnOptions.entries()) {
        options.push({
          text,
          value: index,
        });
      }
    }

    return options;
  }

  openPreference() {
    this.router.navigateByUrl("/account?navigate=preference");
  }
  onDateChange(event) {
    const value = event?.detail?.value;
    if (value) {
      let formattedDate = moment(value).format("MM/DD/yyyy");
      this.completeRegistrationForm.get("date_of_birth").patchValue(formattedDate);
      this.dobDate = event.detail.value;
      this.defaultDateOfBirth = event.detail.value;

      this.completeRegistrationForm
        .get('date_of_birth')
        ?.markAsTouched();

      this.completeRegistrationForm
        .get('date_of_birth')
        ?.updateValueAndValidity();
    }
    //comment this code for future use
    //popover.dismiss();
  }
  public autoFill(event, type) {
    const emailValue = event?.target?.value;
    // Set the value of 'cemail' to be the same as 'email'
    this.completeRegistrationForm.get(type).setValue(emailValue);
  }
  dateCalculator() {
    const storedDob = this.paidProfileMode || this.hasConfirmedPaidJourney() || this.profileRequiresScopedSnapshot
      ? null : localStorage.getItem("defaultDob");
    if (storedDob) {
      this.defaultDateOfBirth = storedDob;
      return;
    }

    const today = new Date();

    // Calculate the date 18 years ago from today
    const minDOB = new Date(today.getFullYear() - 18, today.getMonth(), today.getDate());

    // Format the minimum date for the input field
    this.defaultDateOfBirth = minDOB.toISOString().split("T")[0];
  }

  /**
   * Open date picker modal when input is clicked
   */
  openDateModal(event: Event) {
    event.preventDefault();
    event.stopPropagation();

    if (this.isDateModalOpen) return;

    this.isDateModalOpen = true;
    const control = this.completeRegistrationForm.get('date_of_birth');
    control?.markAsTouched();
    control?.updateValueAndValidity();
    // open modal here
  }


  /**
   * Close date picker modal
   * Called when backdrop is clicked or date is selected
   */
  closeDateModal() {
    this.isDateModalOpen = false;
  }


  public completeRegistrationIfValidUser(): void {
    this.authService.commonUserCheck(() => {
      this.CompleteRegistration();
    });
  }

  checkInput(e) {
    let value;
    const currentInput = e?.target?.value;
    const DEFAULT_VALUE = "+";
    const currentInputDefaultPart = currentInput.substring(0, DEFAULT_VALUE.length);
    // check if the default part is no longer same as DEFAULT
    if (currentInputDefaultPart !== DEFAULT_VALUE) {
      // reset
      value = DEFAULT_VALUE;
      this.completeRegistrationForm.get("dialCode").setValue(value);
    }
  }
  getNumericOnly(event: any): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode >= 48 && charCode <= 57) {
      return true;
    }
    return false;
  }
  getPhoneNumber(event) {
    this.newPhoneNumber = event?.target?.value;
    // Enforce maximum length of 10 characters for phoneNumber
    const maxLength = 11;
    if (this.newPhoneNumber.length > maxLength) {
      this.newPhoneNumber = this.newPhoneNumber.slice(0, maxLength);
    }
    // Validate phone number format (you can customize this validation based on your needs)
    const phoneNumberRegex = /^0?\d+$/; // Only allow digits
    const isPhoneNumberValid = phoneNumberRegex.test(this.newPhoneNumber);
    // Always set the combined value to phoneNumber without the dial code
    const displayedPhoneNumber = this.newPhoneNumber;
    // Only the phone number without dial code
    this.completeRegistrationForm.get("phoneNumber").setValue(displayedPhoneNumber);
    // Set or clear the error based on the phone number validity
    if (!isPhoneNumberValid) {
      this.completeRegistrationForm.get("phoneNumber").setErrors({ incorrectPhoneNumber: true });
    } else {
      this.completeRegistrationForm.get("phoneNumber").setErrors(null);
    }
  }
  onCell1CountryChange(event) {
    // Extract event data outside Angular zone to prevent Java bridge errors on Android WebView
    this.countryCode = event?.iso2;
    this.newDialCode = event?.dialCode;
    
    // Process the form update inside Angular zone to ensure proper event handling
    this.ngZone.run(() => {
      this.completeRegistrationForm.get("dialCode").setValue(this.newDialCode);
    });
  }
  telInputObject(event: Data) {
    // Defensive check to prevent race condition where intl-tel-input's internal state
    // object 's' is undefined during library initialization (specifically on iOS/Firefox)
    if (!event || typeof event !== 'object') {
      this.dialCode = "44";
      return;
    }
    
    // Check if the internal state object exists before accessing properties
    if (event.s && typeof event.s === 'object' && event.s.dialCode) {
      this.dialCode = event.s.dialCode;
    } else {
      this.dialCode = "44";
    }
  }

  phoneNumberHasError(hasError: boolean) {
    this.incorrectPhoneNumber = hasError;
    this.completeRegistrationForm.get("phoneNumber").setErrors({
      incorrectPhoneNumber: !hasError,
    });
    if (this.phoneNumberInput) this.phoneInValid = this.phoneNumberInput.nativeElement.value ? true : false;
  }
  // Function to remove the country code from the phone number
  removeCountryCode(msn: string, countryCode: string): string {
    if (msn.startsWith(countryCode)) {
      return msn.slice(countryCode.length);
    }
    return msn;
  }
}
